import SvgIcon from '@mui/material/SvgIcon';

export default function LogoSVGNew({ width = 200, height = 40 }: { width?: number, height?: number }) {
    return (
        <SvgIcon sx={{ width, height }} viewBox="0 0 189.6 35.8">
            <g>
                <path
                    fill="#FFFFFF"
                    d="M44.1,17.5c0-6.5,3.8-10.2,9.7-10.2s8.3,2.8,8.9,7.6l-4.5.9c-.5-2.9-1.8-4.4-4.5-4.4s-4.9,2.7-4.9,6.1,1.5,6.3,4.9,6.3,4.1-1.5,4.7-4.5l4.5.8c-.6,4.9-3.8,7.8-9.1,7.8S44.1,24,44.1,17.5Z"
                />
                <path
                    fill="#FFFFFF"
                    d="M73.5,23.7h-.4c-.8,2.5-2.4,4-5.1,4s-4.6-1.3-4.6-4.4,1.6-4.7,5.7-4.7h4.1v-1.1c0-1.6-.7-2.5-2.4-2.5s-2.3.7-2.6,2.2l-4.2-1c.5-2.8,2.7-4.8,7-4.8s6.7,2.2,6.7,6.1v9.9h-4.2v-3.7Z"
                />
                <path
                    fill="#FFFFFF"
                    d="M78.9,22.9l4-.8c.4,1.7,1.4,2.6,3.4,2.6s2.3-.5,2.3-1.5c0-1-.6-1.5-3.5-2-4.3-.9-5.7-2.3-5.7-5s2.1-4.8,6.5-4.8,6,1.8,6.6,4.5l-4,.8c-.4-1.6-1.1-2.2-2.7-2.2s-2.2.5-2.2,1.4.4,1.5,3.2,2c4.9,1,6,2.6,6,5.1s-2,4.9-6.7,4.9-6.9-2.1-7.3-4.9Z"
                />
                <circle fill="#37de3d" cx="18.5" cy="25.6" r="6.2" />
                <circle fill="#37de3d" cx="10.3" cy="17.9" r="6.2" />
                <circle fill="#37de3d" cx="18.3" cy="9.6" r="6.2" />
                <circle fill="#37de3d" cx="26.5" cy="17.3" r="6.2" />
            </g>
        </SvgIcon>
    );
}
